import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

import { AccionDetalle, IInitialState } from '../../Shared/data/FormReducer';
import NavigationSideBar from '../shared/General/NavigationSideBar';
import NavigationSideBarMobile from '../shared/General/NavigationSideBarMobile';

interface IHeader {
  state: IInitialState;
  dispatch: React.Dispatch<AccionDetalle>;
  routes: React.ReactElement | null;
}

const Header: React.FC<IHeader> = (props) => {
  const [selectedPage, setSelectedPage] = useState<number>(0);
  const matches = useMediaQuery('(min-width:650px)');
  return (
    <>
      {matches ? (
        <NavigationSideBar
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          state={props.state}
          routes={props.routes}
        />
      ) : (
        <NavigationSideBarMobile
          selectedPage={selectedPage}
          setSelectedPage={setSelectedPage}
          state={props.state}
          routes={props.routes}
        />
      )}
    </>
  );
};

export default Header;
